"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensSubplaceParamsProvider = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
class LensSubplaceParamsProvider extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(data_catalog_shared_1.UrlSearchProvider, null, urlSearch => (react_1.default.createElement(LensSubplaceParamsProviderInternal, { urlSearch: urlSearch }, this.props.children))));
    }
}
exports.LensSubplaceParamsProvider = LensSubplaceParamsProvider;
class LensSubplaceParamsProviderInternal extends react_1.default.Component {
    render() {
        return this.props.children({
            urlSearchValue: this.props.urlSearch.value,
        });
    }
}
//# sourceMappingURL=LensSubplaceParamsProvider.js.map